import CastModal from './cast/modal';

const modal = new CastModal();